<template>
  <div class="radialIndicatorContainer">
    <div class="percentloop">
      <div class="circle-left">
        <div ref="leftcontent"></div>
      </div>
      <div class="circle-right">
        <div ref="rightcontent"></div>
      </div>
      <div class="content-wrap">
        <span class="contentNumber"><span style="font-size: 0.16rem">{{ percent }}</span>%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadialIndicator',

  props: {
    size: {
      type: [String, Number],
      default: 155
    },
    icon: {
      type: String,
      default: 'mail'
    },
    content: String,
    color: {
      type: String,
      default: '#00b3ef'
    },
    backgroundColor: {
      type: String,
      default: '#7fd9f7'
    },
    percentNum: {
      type: [String, Number],
      default: 0
    },
    speed: {
      // suggest 1~3
      type: [String, Number],
      default: 1
    }
  },

  data() {
    return {
      percent: 0,
      initDeg: 0,
      timeId: null,
      animationing: false
    };
  },

  created() {
    this.goRotate(this.transformToDeg(this.percentNum));
  },

  watch: {
    percentNum: function (val) {
      if (this.animationing) return;
      this.goRotate(this.transformToDeg(val));
    }
  },

  methods: {
    transformToDeg(percent) {
      let deg = 0;
      if (percent >= 100) {
        deg = 360;
      } else {
        deg = parseInt((360 * percent) / 100);
      }
      return deg;
    },

    transformToPercent(deg) {
      let percent = 0;
      if (deg >= 360) {
        percent = 100;
      } else {
        percent = parseInt((100 * deg) / 360);
      }
      return percent;
    },

    //  > 180
    rotateLeft(deg) {
      this.$refs.leftcontent.style.transform = 'rotate(' + (deg - 180) + 'deg)';
    },

    //  < 180
    rotateRight(deg) {
      this.$refs.rightcontent.style.transform = 'rotate(' + deg + 'deg)';
    },

    goRotate(deg) {
      this.animationing = true;
      this.timeId = setInterval(() => {
        if (deg > this.initDeg) {
          this.initDeg += Number(this.speed);
          if (this.initDeg >= 180) {
            this.rotateLeft(this.initDeg);
            this.rotateRight(180);
          } else {
            this.rotateRight(this.initDeg);
          }
        } else {
          this.initDeg -= Number(this.speed);
          if (this.initDeg >= 180) {
            this.rotateLeft(this.initDeg);
          } else {
            this.rotateLeft(180);
            this.rotateRight(this.initDeg);
          }
        }
        this.percent = this.transformToPercent(this.initDeg);
        const remainer = Number(deg) - this.initDeg;
        if (Math.abs(remainer) < this.speed) {
          this.initDeg += remainer;
          if (this.initDeg > 180) {
            this.rotateLeft(deg);
          } else {
            this.rotateRight(deg);
          }
          this.animationFinished();
        }
      }, 10);
    },

    animationFinished() {
      this.percent = this.percentNum;
      this.animationing = false;
      clearInterval(this.timeId);
      this.$emit('animationFinished');
    }
  }
};
</script>

<style lang="less"  scoped>
.radialIndicatorContainer {
  width: 0.58rem;
  height: 0.58rem;
  .percentloop {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}

.radialIndicatorContainer .circle-left,
.radialIndicatorContainer .circle-right {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  background-color: #00a4b0;
}

.radialIndicatorContainer .circle-left > div,
.radialIndicatorContainer .circle-right > div {
  width: 100%;
  height: 100%;
  transform-origin: right center;
  background: #e4e4e4;
}

.radialIndicatorContainer .circle-right {
  left: 50%;
}

.radialIndicatorContainer .circle-right > div {
  transform-origin: left center;
}

.radialIndicatorContainer .content-wrap {
  position: absolute;
  top: 0.09rem;
  bottom: 0.09rem;
  left: 0.09rem;
  right: 0.09rem;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.radialIndicatorContainer .content-wrap .contentNumber {
  font-size: 0.12rem;
  font-family: Hiragino Sans;
  color: #333333;
  padding: 5px 0 7px 0;
}

.radialIndicatorContainer .content-wrap .content-text {
  display: inline-block;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/progressBar/cRadialIndicator.vue